module.exports = __webpack_public_path__ + "custom-config/img/renzhenglianmeng.4c9faf7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/commons/footer/renzhenglianmeng.png
// module id = feRo
// module chunks = 2 3 4 6 7 8 9